// The same brand marks as the report's channel cards and the Planning board
// (public/platforms/*.svg), so a platform looks identical everywhere.
const logoFile = (platform: string): string | null => {
  const name = platform.toLowerCase();
  if (name.includes("meta") || name.includes("facebook")) return "meta";
  if (name.includes("google")) return "google";
  if (name.includes("tiktok")) return "tiktok";
  if (name.includes("microsoft") || name.includes("bing")) return "microsoft";
  if (name.includes("pinterest")) return "pinterest";
  if (name === "x" || name.startsWith("x ads")) return "x";
  return null;
};

export function PlatformLogo({ platform }: { platform: string }) {
  const file = logoFile(platform);
  return file
    ? <img className={`platform-logo platform-logo--${file}`} src={`/platforms/${file}.svg`} alt="" aria-hidden="true" />
    : <span className="platform-logo platform-logo--generic" aria-hidden="true" />;
}
